import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, filter, map, startWith, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private readonly _bildungsangeboteLoading$ = new BehaviorSubject<boolean>(false);
  private readonly _facettenLoading$ = new BehaviorSubject<boolean>(false);
  private readonly _anbieterFacetteLoading$ = new BehaviorSubject<boolean>(false);
  private readonly _angebotTermineLoading$ = new BehaviorSubject<boolean>(false);
  private readonly _angeboteTriggeredByPageChange$ = new BehaviorSubject<boolean>(false);
  private readonly _themenfelderLoading$ = new BehaviorSubject<boolean>(false);
  private readonly _themenfeldSchwerpunkteLoading$ = new BehaviorSubject<boolean>(false);
  private readonly _themenfeldSpezialisierungenLoading$ = new BehaviorSubject<boolean>(false);
  private readonly _suchwortCountsLoading$ = new BehaviorSubject<boolean>(false);

  public bildungsangeboteLoading$ = this._bildungsangeboteLoading$.asObservable();
  public facettenLoading$ = this._facettenLoading$.asObservable();
  public anbieterFacetteLoading$ = this._anbieterFacetteLoading$.asObservable();
  public angebotTermineLoading$ = this._angebotTermineLoading$.asObservable();
  public angeboteTriggeredByPageChange$ = this._angeboteTriggeredByPageChange$.asObservable();
  public themenfelderLoading$ = this._themenfelderLoading$.asObservable();
  public themenfeldSchwerpunkteLoading$ = this._themenfeldSchwerpunkteLoading$.asObservable();
  public themenfeldSpezialisierungenLoading$ =
    this._themenfeldSpezialisierungenLoading$.asObservable();
  public suchwortCountsLoading$ = this._suchwortCountsLoading$.asObservable();

  public facettenLoadingFirstTime$ = this.facettenLoading$.pipe(
    filter((loading) => loading === false),
    startWith(true),
    take(2)
  );

  public angeboteLoadingByPageChange$ = combineLatest([
    this.angeboteTriggeredByPageChange$,
    this.bildungsangeboteLoading$
  ]).pipe(
    map(
      ([angeboteTriggeredByPageChange, bildungsangeboteLoading]) =>
        angeboteTriggeredByPageChange && bildungsangeboteLoading
    )
  );

  public angeboteLoadingWithoutPageChange$ = combineLatest([
    this.angeboteTriggeredByPageChange$,
    this.bildungsangeboteLoading$
  ]).pipe(
    map(
      ([angeboteTriggeredByPageChange, bildungsangeboteLoading]) =>
        !angeboteTriggeredByPageChange && bildungsangeboteLoading
    )
  );

  public setAngebotTermineLoading(isLoading: boolean): void {
    this._angebotTermineLoading$.next(isLoading);
  }

  public setAngeboteLoading(isLoading: boolean): void {
    this._bildungsangeboteLoading$.next(isLoading);
    if (!isLoading) {
      this._angeboteTriggeredByPageChange$.next(false);
    }
  }

  public setFacettenLoading(isLoading: boolean): void {
    this._facettenLoading$.next(isLoading);
  }

  public setAnbieterFacetteLoading(isLoading: boolean): void {
    this._anbieterFacetteLoading$.next(isLoading);
  }

  public setAngeboteTriggeredByPageChange(): void {
    this._angeboteTriggeredByPageChange$.next(true);
  }

  public setThemenfelderLoading(isLoading: boolean): void {
    this._themenfelderLoading$.next(isLoading);
  }

  public setThemenfeldSchwerpunkteLoading(isLoading: boolean): void {
    this._themenfeldSchwerpunkteLoading$.next(isLoading);
  }

  public setThemenfeldSpezialisierungenLoading(isLoading: boolean): void {
    this._themenfeldSpezialisierungenLoading$.next(isLoading);
  }

  public setSuchwortCountsLoading(isLoading: boolean): void {
    this._suchwortCountsLoading$.next(isLoading);
  }
}
